__turbopack_context__.v({
  "contactButton": "MiniContactPanel-module-scss-module__hbv7mq__contactButton",
  "divider": "MiniContactPanel-module-scss-module__hbv7mq__divider",
  "footer": "MiniContactPanel-module-scss-module__hbv7mq__footer",
  "profileImageContainer": "MiniContactPanel-module-scss-module__hbv7mq__profileImageContainer",
  "shareButton": "MiniContactPanel-module-scss-module__hbv7mq__shareButton",
  "stickyNav": "MiniContactPanel-module-scss-module__hbv7mq__stickyNav",
  "text": "MiniContactPanel-module-scss-module__hbv7mq__text",
});
